import { OnePagerContext } from './context';
import { OnePagerSectionConfig } from '../editor/dealSummaryEditorInitializer';
import { BANKING_HEADERS } from '../editor/dealSummaryEditorConstants';
import { Cell, h2, spacer, table, td, text, th, tr, TrRow } from './plateNodes';

export function buildBankingSection(ctx: OnePagerContext, section: OnePagerSectionConfig): any[] | null {
    const { bankingOverviewList } = ctx;

    if (!bankingOverviewList?.length) return null;

    const headerRow: TrRow = tr(BANKING_HEADERS.map((header) => th([text(header.label, { bold: true })])));

    const dataRows: TrRow[] = bankingOverviewList.map((bank: any) => {
        const totalsRow = !!bank?.isTotalsRow;
        const cells: Cell[] = BANKING_HEADERS.map((header) =>
            totalsRow ? th([text(String(bank?.[header.key] ?? '-'), { bold: true })]) : td([text(String(bank?.[header.key] ?? '-'))]),
        );
        return tr(cells);
    });

    return [h2([text(section.label)]), table([headerRow, ...dataRows]), spacer()];
}
